import React from 'react'

const Profile = () => {
  return (
    <svg
    id="icon-user2"
    xmlns="http://www.w3.org/2000/svg"
    className="text-primary"
    width={18}
    height={18}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth={2}
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
    <circle cx={12} cy={7} r={4} />
  </svg>
  )
}

export default Profile
